/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePLanRequestPlan
 */
export interface UpdatePLanRequestPlan {
}

/**
 * Check if a given object implements the UpdatePLanRequestPlan interface.
 */
export function instanceOfUpdatePLanRequestPlan(value: object): value is UpdatePLanRequestPlan {
    return true;
}

export function UpdatePLanRequestPlanFromJSON(json: any): UpdatePLanRequestPlan {
    return UpdatePLanRequestPlanFromJSONTyped(json, false);
}

export function UpdatePLanRequestPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePLanRequestPlan {
    return json;
}

export function UpdatePLanRequestPlanToJSON(json: any): UpdatePLanRequestPlan {
    return UpdatePLanRequestPlanToJSONTyped(json, false);
}

export function UpdatePLanRequestPlanToJSONTyped(value?: UpdatePLanRequestPlan | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

